import CounterLines from "./CounterLines";
import Flex from "app/components/UI/Flex";
import Icon from "app/components/UI/Icon";
import ImmutablePropTypes from "react-immutable-proptypes";
import PropTypes from "prop-types";
import React from "react";
import SearchInput from "app/components/UI/SearchInput";
import Spinner from "app/components/UI/Spinner";
import Title from "app/components/UI/Title";
import classes from "./Counter.module.css";

const Counter = ({ translate, onNumberChange, number, counterLines, isLoading, notFound }) => (
  <div className={classes.pageContainer}>
    <Title>Consulter mon solde</Title>
    <div className={classes.counterPageContainer}>
      <div className={classes.searchContainer}>
        <Flex direction="row" middle>
          <Icon className={classes.search__icon}>search</Icon>
          <SearchInput
            className={classes.search__field}
            onChange={onNumberChange}
            value={number}
            placeholder={translate("Rechercher par numéro de badge")}
            block
          />
        </Flex>
      </div>
      {isLoading ? (
        <Spinner className={classes.spinner} />
      ) : (
        <CounterLines counterLines={counterLines} notFound={notFound} />
      )}
    </div>
  </div>
);

Counter.propTypes = {
  translate: PropTypes.func.isRequired,
  onNumberChange: PropTypes.func.isRequired,
  number: PropTypes.string,
  counterLines: ImmutablePropTypes.list,
  isLoading: PropTypes.bool.isRequired,
  notFound: PropTypes.bool.isRequired
};

export default Counter;



// WEBPACK FOOTER //
// ./src/app/components/Counter/Counter.js